import { render, staticRenderFns } from "./TimeAndCorrectAnswersComponent.vue?vue&type=template&id=6faabc92&scoped=true&"
import script from "./TimeAndCorrectAnswersComponent.vue?vue&type=script&lang=js&"
export * from "./TimeAndCorrectAnswersComponent.vue?vue&type=script&lang=js&"
import style0 from "./TimeAndCorrectAnswersComponent.vue?vue&type=style&index=0&id=6faabc92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faabc92",
  null
  
)

export default component.exports